import { useMutation } from "react-query";
import { deleteInterventionHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useDeleteInterventionHistory = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteInterventionHistory(id),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Intervention record deleted successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to delete intervention record";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    deleteInterventionHistoryMutation: mutate,
    isDeleteInterventionHistoryLoading: isLoading,
    ...rest,
  };
};

export default useDeleteInterventionHistory;
